/*
  Joryel Vera destek sohbeti - AI destekli (Claude, Cloudflare Worker uzerinden).
  Worker URL'i bos birakilirsa bot devre disi kalir gibi davranir (sadece
  WhatsApp/Contact secenegi gosterilir) - hicbir sey uydurmaz, sessizce bozulmaz.
*/
(function () {
  var STARTER_PROMPTS = [
    'How long does shipping take?',
    'Is this real sterling silver?',
    'What is your return policy?',
    'How do I become a retailer?',
  ];

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.jv-chat');
    if (!root) return;

    var trigger = root.querySelector('.jv-chat__trigger');
    var closeBtn = root.querySelector('.jv-chat__close');
    var body = root.querySelector('.jv-chat__body');
    var form = root.querySelector('.jv-chat__input-row');
    var input = root.querySelector('.jv-chat__input');
    var sendBtn = root.querySelector('.jv-chat__send');
    var workerUrl = (root.getAttribute('data-worker-url') || '').trim();
    var history = [];
    var busy = false;

    function toggle(open) {
      var willOpen = open !== undefined ? open : !root.classList.contains('is-open');
      root.classList.toggle('is-open', willOpen);
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (willOpen && body.children.length === 0) {
        renderGreeting();
      }
      if (willOpen) {
        setTimeout(function () {
          input.focus();
        }, 150);
      }
    }

    trigger.addEventListener('click', function () {
      toggle();
    });
    closeBtn.addEventListener('click', function () {
      toggle(false);
    });

    function scrollToBottom() {
      body.scrollTop = body.scrollHeight;
    }

    function addBubble(text, isUser) {
      var bubble = document.createElement('div');
      bubble.className = 'jv-chat__bubble' + (isUser ? ' jv-chat__bubble--user' : '');
      bubble.textContent = text;
      body.appendChild(bubble);
      scrollToBottom();
      return bubble;
    }

    function addTyping() {
      var bubble = document.createElement('div');
      bubble.className = 'jv-chat__bubble jv-chat__bubble--typing';
      bubble.innerHTML = '<span></span><span></span><span></span>';
      body.appendChild(bubble);
      scrollToBottom();
      return bubble;
    }

    function renderStarters() {
      var existing = body.querySelector('.jv-chat__topics');
      if (existing) existing.remove();

      var wrap = document.createElement('div');
      wrap.className = 'jv-chat__topics';

      var label = document.createElement('p');
      label.className = 'jv-chat__topic-label';
      label.textContent = 'Quick questions';
      wrap.appendChild(label);

      STARTER_PROMPTS.forEach(function (q) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'jv-chat__chip';
        chip.textContent = q;
        chip.addEventListener('click', function () {
          sendMessage(q);
        });
        wrap.appendChild(chip);
      });

      body.appendChild(wrap);
      scrollToBottom();
    }

    function renderGreeting() {
      body.innerHTML = '';
      addBubble(
        "Hi, I'm the Joryel Vera chat assistant. Ask me anything about the pieces, shipping, or our story."
      );
      renderStarters();
    }

    function removeStarters() {
      var existing = body.querySelector('.jv-chat__topics');
      if (existing) existing.remove();
    }

    function sendMessage(text) {
      var message = (text || '').trim();
      if (!message || busy) return;

      removeStarters();
      addBubble(message, true);
      input.value = '';

      if (!workerUrl) {
        addBubble("I'm not able to chat right now — please reach us from the option below.");
        return;
      }

      busy = true;
      sendBtn.disabled = true;
      var typingBubble = addTyping();

      fetch(workerUrl, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ message: message, history: history }),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          typingBubble.remove();
          var reply = (data && data.reply) || "Sorry, I couldn't answer that — please try the option below.";
          addBubble(reply);
          history.push({ role: 'user', content: message });
          history.push({ role: 'assistant', content: reply });
          if (history.length > 12) history = history.slice(-12);
        })
        .catch(function () {
          typingBubble.remove();
          addBubble("Sorry, I'm having trouble connecting — please try the option below.");
        })
        .finally(function () {
          busy = false;
          sendBtn.disabled = false;
          input.focus();
        });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      sendMessage(input.value);
    });
  });
})();
